import React, { Component } from "react";
import { connect } from "react-redux";
import { actions as modalActions } from "@/bit/reducers/next13.reducers.modals-reducer";
import IconGlyph from "@/bit/components/next13.components.icon-glyph";
import CustomLink from "@/bit/components/next13.components.custom-link";
import SupportAndSearch from "../modals/support-search";
import SearchInput from "./search-input";

class Searcher extends Component {
  constructor() {
    super();
  }

  openSearchModal = () => {
    const { addModal } = this.props;
    addModal({
      id: "searcher",
      Element2Show: SupportAndSearch,
      modalProps: {
        contentPosition: "center--top",
        opacityLayoutColor: "blur",
        inSceneEffect: "fadeIn",
        closeAllOnClickOutside: true,
        contentInsideContainer: true,
        outSceneEffect: "fadeOut",
        closeByClickingOutside: true,
      },
      elementProps: {
        visibleInput: true,
      },
    });
  };
  render() {
    return (
      <>
        <div className="searcher-desktop">
          <SearchInput {...this.props} className="desktop" />
        </div>
        <div className="searcher-mobile">
          <CustomLink
            onClick={this.openSearchModal}
            taggingInfo={{
              componentName: "header",
              componentContent: "openSearcher",
              componentVariation: "all",
              componentPerso: "",
              componentProduct: "",
            }}
            cyData="Header icon search"
          >
            <IconGlyph color="grey6" id="buscar-m" width={22} />
          </CustomLink>
          <style jsx>{`:global(.searcher-mobile) {
  display: block;
}
:global(.searcher-desktop) {
  display: none;
}

:global(.icon-searcher) {
  display: inline-flex;
  padding: 0.5rem;
}

@media screen and (min-width: 768px) {
  :global(.searcher-mobile) {
    display: none;
  }
  :global(.searcher-desktop) {
    display: block;
    width: inherit;
  }

  :global(.icon-searcher) {
    display: none;
  }
}
`}</style>
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  addModal: (data) => dispatch(modalActions.addModal(data)),
});

export default connect(null, mapDispatchToProps)(Searcher);
